import React from 'react';
import { ButtonModifyAnExchange } from './ButtonModifyAnExchange';
import { ButtonCancellation } from './ButtonCancellation';
import { ResolutionCenterButton } from './ResolutionCenterButton';
import { Flex } from '@homeexchange/design';
import { useDevice } from '@homeexchange/shared';
export var ExchangeInfosButtons = function (_a) {
    var conversation = _a.conversation, user = _a.user;
    var shouldDisplayResolutionCenterButton = function () {
        var exchanges = conversation.get('exchanges');
        return (exchanges.every(function (exchange) { return exchange.isFinalized() && !exchange.hasStartDatePassed(); }) && exchanges.some(function (exchange) { return exchange.get('can_declare_incident'); }));
    };
    var isDesktop = useDevice().isDesktop;
    var displayResolutionCenterButton = shouldDisplayResolutionCenterButton();
    return (React.createElement(Flex, { gap: "4", direction: isDesktop ? 'row' : 'column', isFullWidth: true, flexGrow: !isDesktop, className: "exchange-infos-buttons", flexWrap: "wrap" },
        React.createElement(ButtonModifyAnExchange, { conversation: conversation, user: user, isFullWidth: !isDesktop }),
        displayResolutionCenterButton && (React.createElement(ResolutionCenterButton, { conversationId: conversation.id, isFullWidth: !isDesktop })),
        React.createElement(ButtonCancellation, { user: user, conversation: conversation, isFullWidth: !isDesktop })));
};
